export default __webpack_public_path__ + "static/media/icon_arrow_right_mobile.8f27b961.svg";